import React from 'react';
import { ButtonToolbar, Button, Panel, Tab, Alert, Nav, NavItem, Row, Col } from 'react-bootstrap';
import moment from 'moment-business-days';
import { addContract, updateContract } from 'utils/ContractsAPIUtils';
import Store from 'stores/ContractsStore';
import ContractPropsEditor from './ContractPropsEditor';
import TariffRatesList from './TariffRatesList';
import AccessorialRatesList from './AccessorialRatesList';
import ContractValidator from './ContractValidator';

export default class ContractsEditorModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            contract: Store.getContractById(this.props.match.params.id) || this.newContract(),
        };
        this.onChange = () => this.onStoreChange();
    }

    componentDidMount() {
        Store.addChangeListener(this.onChange);
    }

    componentWillUnmount() {
        Store.removeChangeListener(this.onChange);
    }

    onStoreChange() {
        if (Store.getStatus() === 'success') {
            const propsContract = Store.getContractById(this.props.match.params.id);
            const storeContract = Store.getContract();
            if (storeContract._id) {
                this.setState({ contract: storeContract, hasBeenEdited: false });
            } else {
                this.setState({ contract: propsContract, hasBeenEdited: false });
            }
        } else {
            this.setState({ hasBeenEdited: true });
        }
}

    save() {
        return () => {
            if (this.state.contract) {
                Store.reset();
                addContract(this.state.contract);
            }
            this.setState({ hasBeenEdited: false });
        };
    }

    update() {
        return () => {
            if (this.state.contract) {
                Store.reset();
                updateContract(this.state.contract);
            }
            this.setState({ hasBeenEdited: false });
        };
    }

    handlePropertiesChange() {
        return (key, value) => {
            const contract = this.state.contract;
            contract[key] = value;
            this.setState({ hasBeenEdited: true, contract: contract });
        };
    }

    isValid(value) {
        return value && value.length > 0;
    }

    validateDate(startDate, endDate) {
        const start = moment(startDate);
        const end = moment(endDate);

        if (start.isAfter(end)) {
            return false;
        } else if (end.isBefore(moment())) {
            return false;
        }
        return true;
    }

    setStatus() {
        return () => {
            const result = ContractValidator(this.state.contract);
            let status = this.state.contract.status;
            if (result.value) {
                if (status !== 'expired') {
                    status = (status === 'active') ? 'hold' : 'active';
                }
            }
            this.state.contract.status = status;
            this.state.alert = result.info;
            this.setState();
            this.update();
        };
    }

    newContract() {
        return {
            contract_name: '',
            parties: 'shipper',
            start_date: new Date(),
            expiration_date: new Date(),
            status: 'draft',
            user: '',
            user_name: '',
            term: 0,
            tariff_rates: [],
            accessorial_rates: [],
        };
    }

    render() {
        const valid = this.isValid(this.state.contract.contract_name) && this.isValid(this.state.contract.user) && this.validateDate(this.state.contract.start_date, this.state.contract.expiration_date);
        const newContractMode = (!this.state.contract || !this.state.contract._id);
        const disableSaveButton = (!this.state.hasBeenEdited && !newContractMode) || !valid;
        let alert = '';
        if (this.state.alert) {
            alert = (
              <Alert bsStyle="danger">
                {this.state.alert}&nbsp;&nbsp;
                <Button onClick={() => this.setState({ alert: '' })}>Hide Alert</Button>
              </Alert>);
        }
        return (
          <div >
            <div>
              {alert}
              <Tab.Container id="left-tabs-example" defaultActiveKey="1">
                <Row className="clearfix">
                  <Col sm={2}>
                    <Nav bsStyle="pills" stacked>
                      <NavItem eventKey="1">
                                    Properties
                                </NavItem>
                      <NavItem eventKey="2" disabled={newContractMode}>
                                    TariffRates
                                </NavItem>
                      <NavItem eventKey="3" disabled={newContractMode}>
                                    AccessorialRates
                                </NavItem>
                    </Nav>
                  </Col>
                  <Col sm={10}>
                    <Tab.Content animation>
                      <Tab.Pane eventKey="1">
                        <Panel>
                          <ContractPropsEditor
                            contract={this.state.contract}
                            onChange={this.handlePropertiesChange()}
                          />
                        </Panel>
                      </Tab.Pane>
                      <Tab.Pane eventKey="2">
                        <Panel className="table-responsive">
                          <TariffRatesList
                            contract={this.state.contract}
                          />
                        </Panel>
                      </Tab.Pane>
                      <Tab.Pane eventKey="3">
                        <Panel className="table-responsive">
                          <AccessorialRatesList
                            contract={this.state.contract}
                          />
                        </Panel>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </div>
            <div style={{ float: 'right' }}>
              <ButtonToolbar>
                <Button
                  bsStyle="primary"
                  disabled={(this.state.contract.status === 'expired') || (newContractMode)}
                  onClick={this.setStatus()}
                >
                  {(this.state.contract.status === 'active') ? 'Hold' : 'Active'}
                </Button>
                <Button
                  bsStyle="primary"
                  disabled={disableSaveButton}
                  onClick={(newContractMode) ? this.save() : this.update()}
                >
                  {(newContractMode) ? 'Save' : 'Save Changes'}
                </Button>
              </ButtonToolbar>
            </div>
          </div>
        );
    }
}
